import { unflatten } from 'flat'
import { Doctor, DoctorApi, DoctorFormData, DoctorFormDataApi, DoctorFormErrors, DoctorFormErrorsApi } from '../types'
import { v1 as uuid } from 'uuid'

export class DoctorMappers {
  public static fromApi(raw: DoctorApi): Doctor {
    return {
      id: raw.id,
      firstname: raw.name,
      lastname: raw.surname,
      patronymic: raw.patronymic,
      services:
        raw.services?.map(({ service_id, service_name, percent, hide, fix_amount, earning_type }) => ({
          id: service_id,
          name: service_name,
          percent: parseFloat(percent || '0'),
          amount: parseFloat(fix_amount),
          earningType: earning_type === 'percent' ? 'percent' : 'fix',
          visible: !hide,
        })) || [],
      clinic: raw.partner_clinic_id && raw.clinic_name ? { id: raw.partner_clinic_id, name: raw.clinic_name } : null,
      status: { id: raw.state_id, name: raw.state_name },
      phoneNumber: raw.number || '',
      price: raw.price ? parseFloat(raw.price) : 0,
      description: raw.descr || '',
      createdAt: raw.created_at,
    }
  }

  public static collectionFromApi(raw: DoctorApi[]): Doctor[] {
    return raw.map((item) => DoctorMappers.fromApi(item))
  }

  public static formDataToApi(formData: DoctorFormData): DoctorFormDataApi {
    return {
      doctor_id: formData.id,
      name: formData.firstname,
      surname: formData.lastname,
      patronymic: formData.patronymic,
      partner_clinic_id: formData.clinicId,
      services: formData.services
        .filter(({ id }) => !!id)
        .map(({ id, percent, visible, earningType, amount }) => ({
          id,
          percent,
          earning_type: earningType === 'percent' ? 'percent' : 'fix_amount',
          fix_amount: amount,
          hide: Number(!visible).toString(),
        })),
      state_id: formData.statusId,
      price: formData.price,
      number: '994' + formData.phoneNumber,
      descr: formData.description,
    }
  }
  public static formErrorsFromApi(errors: DoctorFormErrorsApi): DoctorFormErrors {
    const { services } = unflatten(errors) as Record<string, any>
    return {
      id: errors.doctor_id?.join(', '),
      firstname: errors.name?.join(', '),
      lastname: errors.surname?.join(', '),
      patronymic: errors.patronymic?.join(', '),
      clinicId: errors.partner_clinic_id?.join(', '),
      services: services?.flat().join(', '),
      statusId: errors.state_id?.join(', '),
      description: errors.descr?.join(', '),
      phoneNumber: errors.number?.join(', '),
      price: errors.price?.join(', '),
      _custom: errors._custom?.join(', '),
    }
  }
  public static formInitializer(doctor: Doctor): DoctorFormData {
    return {
      id: doctor.id.toString(),
      firstname: doctor.firstname,
      lastname: doctor.lastname,
      patronymic: doctor.patronymic,
      clinicId: doctor.clinic?.id.toString() || '',
      services: !!doctor.services.length
        ? doctor.services.map(({ id, percent, visible, earningType, amount }) => ({
            uuid: uuid(),
            id: id.toString(),
            earningType,
            percent: percent.toString(),
            amount: amount.toString(),
            visible,
          }))
        : [{ uuid: uuid(), id: '', percent: '0', amount: '0', earningType: 'percent', visible: true }],
      statusId: doctor.status.id.toString(),
      price: doctor.price.toString(),
      phoneNumber: doctor.phoneNumber.replace('+', '').replace('994', ''),
      description: doctor.description,
    }
  }
}
